import React from 'react';
import '../Assets/css/scrollbar.css';
import camaco from '../Assets/Images/image (10).png';
import LT from '../Assets/hhg_imgs/56_5.webp';
import hitachi from '../Assets/hhg_imgs/56_3.webp';
import recaro from '../Assets/hhg_imgs/56_1.webp';
import THERMAX_Logo from '../Assets/hhg_imgs/56_4.webp';

const clientLogos = [camaco, LT,THERMAX_Logo, recaro ];

const ScrollBar = () => {
  return (
    <div className="scrollbar-wrapper">
      <div className="client-track">
        {clientLogos.map((logo, index) => (
          <div key={index} className="client-slider">
            <div className="image-list">
              <img src={logo} className="logo-img" alt={`client-${index}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScrollBar;
